var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"tippy",rawName:"v-tippy",value:({placement: 'left'}),expression:"{placement: 'left'}"}],attrs:{"content":"Projects"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"material-icons"},[_vm._v("apps")])])}
var staticRenderFns = []

export { render, staticRenderFns }